import React, { Component } from "react";
import Modal from "react-responsive-modal";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Button, Label, Input } from "@revvsales/components";

// Internal Imports
import { PATHS, EVENTS } from "../../constants";
import { AmplitudeUtils, GlobalUtils } from "../../utils";

import { DocumentTemplateActions } from "../../actions";

// Destructuring
const { writeDataToLocalStorage } = GlobalUtils;
const { cloneTemplate } = DocumentTemplateActions;

class CloneTemplatePopup extends Component {
  state = { clonedTempName: "", showButtunLoader: false, errMsg: "" };

  componentDidMount() {
    this.setState({
      clonedTempName: this.props.docName,
    });
  }

  _onInputChange = e => {
    this.setState({ clonedTempName: e.target.value });
  };

  _cloneTemplateHandler = () => {
    this.setState({ showButtunLoader: true, errMsg: "" });

    this.props
      .cloneTemplate(this.props.id, this.state.clonedTempName)
      .then(response => {
        AmplitudeUtils.amplitudeLogEvent(EVENTS.EVENT_NAMES.TEMPLATE_CLONED, {
          templateID: response.Template.id,
          isActive: response.Template.Active,
          status: response.Template.status,
          tag:
            response.Template.template_tag &&
            response.Template.template_tag.name,
          name: response.Template.title,
        });
        this.setState({ showButtunLoader: false, errMsg: "" });
        const { Template } = response;
        const { id } = Template;
        this.props.closePopup();
        writeDataToLocalStorage("documentPageSource", "templates");
        this.props.history.push(`${PATHS.DOCSTEMPLATE_PATH}/${id}`);
        this.setState({ errMsg: "" });
      })
      .catch(error => {
        console.error(
          `CloneTemplatePopup => _cloneTemplateHandler => ${error}`,
        );
        this.setState({
          showButtunLoader: false,
          errMsg: "Something went wrong. Please try again!",
        });
      });
  };

  render() {
    const { clonedTempName, showButtunLoader, errMsg } = this.state;
    const disabled = !clonedTempName;
    const errMsgSpace = errMsg ? (
      <div className="clonetemplatepopup-error-message">{errMsg}</div>
    ) : null;
    return (
      <Modal
        open
        onClose={this.props.closePopup}
        closeOnOverlayClick={false}
        center>
        <div
          className="clonetemplatepopup-wrapper"
          data-test="clonetemplatepopup-wrapper">
          <div
            className="clonetemplatepopup-modal-heading"
            data-test="clonetemplatepopup-modal-heading">
            Customize/Clone document Template
          </div>
          <div
            className="clonetemplatepopup-modal-subheading"
            data-test="clonetemplatepopup-modal-subheading">
            You can clone and customize the fields in this template to suit your
            needs.
          </div>
          {errMsgSpace}
          <div className="clonetemplatepopup-form">
            <div
              className="clonetemplatepopup-form-field"
              data-test="clonetemplatepopup-templatename">
              <Label
                htmlFor="userEmail"
                data-test="clonetemplatepopup-templatename-label">
                Name of the Cloned template
              </Label>
              <Input
                autoFocus
                className="form-control"
                data-test="clonetemplatepopup-templatename-inputfield"
                type="text"
                name="clonedTempName"
                value={clonedTempName}
                onChange={this._onInputChange}
                placeholder="Enter a template name."
              />
            </div>
          </div>
        </div>
        <div className="createquotepopup-footer popup-footer">
          <div className="footer-actions">
            <Button
              className="btn btn-transparent createquotepopup-footer-cancelbtn"
              data-test="clonetemplatepopup-template-cancel-button"
              onClick={this.props.closePopup}>
              Cancel
            </Button>
            <Button
              data-test="clonetemplatepopup-template-clonetemplate-button"
              disabled={disabled}
              onClick={this._cloneTemplateHandler}
              isLoading={showButtunLoader}>
              Clone Template
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapDispatchToProps = {
  cloneTemplate,
};

export default connect(
  null,
  mapDispatchToProps,
)(withRouter(CloneTemplatePopup));



// WEBPACK FOOTER //
// ./src/components/DocTemplates/CloneTemplatePopup.js